module.exports = __webpack_public_path__ + "static/media/01.b50364a9.jpg";